// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"_1vPyA1","avatar":"_2OrHp6","username":"_1AvqmN"};